import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getShoppingPost, getPostProducts } from "../../services/postService";
import { resolveAssetUrl } from "../../services/apiConfig";
import Button from "../../components/Button/Button";
import styles from "./PostShopping.module.css";

export default function PostShopping() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [result, setResult] = useState(null);
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setState("loading"); setResult(null); setPost(null); setMessage("");
    const load = async () => {
      try {
        const original = await getShoppingPost(postId);
        if (!active) return;
        setPost(original);
        const data = await getPostProducts(postId);
        if (!active) return;
        setResult(data);
        setState(data.groups.length && data.groups.every((group) => group.error) ? "error" : data.groups.some((group) => group.error) ? "partial" : data.products.length ? "ready" : "empty");
        if (data.groups.length && data.groups.every((group) => group.error)) setMessage("Não foi possível buscar produtos agora.");
      } catch (error) {
        if (active) { setMessage(error.response?.data?.message || (error.response?.status === 404 ? "Esta publicação não está disponível. Volte ao feed e abra uma publicação existente." : "Não foi possível buscar produtos similares.")); setState("error"); }
      }
    };
    load();
    return () => { active = false; };
  }, [postId, retry]);

  return <main className={styles.page}>
    <header className={styles.header}><Link to="/homepage">← Voltar ao feed</Link><p className={styles.eyebrow}>Inspire-se neste look</p><h1>Onde encontrar peças similares</h1><p>Veja opções de lojas para as roupas desta publicação.</p></header>
    <div className={styles.layout}>
      {post && <section className={styles.original} aria-label="Publicação original"><img src={resolveAssetUrl(post.image_url)} alt={post.caption || "Foto da publicação"} />{post.user && <Link to={"/profile/" + encodeURIComponent(post.user.username)}>@{post.user.username}</Link>}{post.caption && <p>{post.caption}</p>}</section>}
      <section className={styles.results} aria-label="Produtos similares" aria-busy={state === "loading"}>
        {state === "loading" && <div className={styles.loading} role="status"><span/><span/><span/><p>Identificando as peças e buscando opções nas lojas…</p></div>}
        {state === "error" && <div className={styles.notice} role="alert"><h2>Não foi possível concluir a busca</h2><p>{message}</p><Button type="button" onClick={() => setRetry((value) => value + 1)}>Tentar novamente</Button></div>}
        {state === "empty" && <div className={styles.notice}><h2>{result?.detected_count ? "Nenhum produto similar encontrado" : "Nenhuma peça identificada"}</h2><p>{result?.detected_count ? "Não encontramos opções disponíveis para estas peças agora." : "Não encontramos roupas visíveis nesta foto para fazer a busca."}</p></div>}
        {state === "partial" && <div className={styles.notice}><p>Algumas peças não puderam ser pesquisadas. Você pode tentar novamente para completar a busca.</p><Button type="button" variant="secondary" onClick={() => setRetry((value) => value + 1)}>Tentar novamente</Button></div>}
        {result?.groups.filter((group) => group.products.length).map((group, index) => <section className={styles.group} key={group.clothing_item_id || index}><h2>{group.name}</h2><div className={styles.products}>{group.products.map((product) => <article key={product.source + "-" + product.id}>
          {product.image_url && <img src={product.image_url} alt={product.title} loading="lazy" />}
          {product.sponsored && <small>Patrocinado</small>}{product.affiliate && <small>Link afiliado</small>}
          <h3>{product.title}</h3>{product.store_name && <p>{product.store_name}</p>}
          {product.price != null && product.currency && <strong>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: product.currency }).format(product.price)}</strong>}
          <a href={product.product_url} target="_blank" rel="noopener noreferrer">Ver na loja</a>
        </article>)}</div></section>)}
      </section>
    </div>
  </main>;
}
